import { RankProgress, addWords } from "../lib/rankprogress";
import { h, Component } from 'preact';
import { rankById } from '../lib/ranks';

interface LevelCompletePageProps {
    startingProgress: RankProgress,
    foundWords: number,
    onBack: () => void,
    onPlayAgain: () => void
}

interface LevelCompletePageState {
    animatedProgress: RankProgress
    animatedFoundWords: number,
}

export class LevelCompletePage extends Component<LevelCompletePageProps, LevelCompletePageState> {

    animationTimer: number;
    lastProgress: number;
    constructor(props: LevelCompletePageProps) {
        super(props)
        this.lastProgress = props.startingProgress.progress;
        this.state = {
            animatedProgress: props.startingProgress,
            animatedFoundWords: 0
        }
    }

    stopAnimation = () => {
        window.clearInterval(this.animationTimer)
        this.animationTimer = null;
    }

    animateProgress = () => {
        if (this.state.animatedFoundWords >= this.props.foundWords) {
            this.stopAnimation();
            return;
        }

        this.setState({
            animatedProgress: addWords(this.state.animatedProgress, 1),
            animatedFoundWords: this.state.animatedFoundWords + 1
        })
    }

    startAnimation = () => {
        this.animationTimer = window.setInterval(this.animateProgress, 250);
    }

    componentDidMount() {
        this.startAnimation();
    }

    componentWillUnmount() {
        this.stopAnimation()
    }
    render({onBack, onPlayAgain }:LevelCompletePageProps, { animatedProgress }:LevelCompletePageState ) {
        
        let progressBarStyle:any = { width: animatedProgress.progress+"%", transitionDuration: "0.25s"};
        if (animatedProgress.progress < this.lastProgress) {
            progressBarStyle.transitionDuration = "0s";
        }
        this.lastProgress = animatedProgress.progress;
        return (
            <div class="levelcomplete-screen">
                <div class="title-section">
                    <a class="back-button" onClick={onBack}>&#8249;</a>
                    <span>vowels</span>
                    <a class="help-button" >&nbsp;</a>
                </div>
                <div class="content-section">
                    <div class="content-wrapper grid-complete">
                        <h2>Success!</h2>
                        <div class="rank-section">
                            <span class="rank-label">Rank:</span><span class="rank-name">{rankById(animatedProgress.rankId).name}</span>
                            <div class="rank-progress-bar-wrapper">
                                <div class="rank-progress-bar" style={ progressBarStyle } ></div>
                            </div>
                        </div>
                        <div>
                            <a onClick={onPlayAgain}>Play Again?</a>
                            <a onClick={onBack}>Return to Menu</a>
                        </div>
                       
                    
                    </div>
                </div>
            </div>)
    }
}

